'use client';
import { useState, useEffect } from 'react';
import './MyPaymentMethods.scss';
import 'react-phone-input-2/lib/style.css';
import { useParams, useSearchParams } from 'react-router-dom';
import { PetskedTitle } from '@/components/Heading/PetskedTitle';
import { BackNav } from '@/components/BackNavigation/BackNavigation';
import { Switch } from '@headlessui/react';
import { Header } from '@/features/availability/components/Header';
import { Form } from 'react-bootstrap';
import { CreditCard, BillingList } from '@/features/auth';
import { ReactComponent as VisaIcon } from '@/assets/img/v2/visa-card-icon.svg';
import RetryIcon from '@/assets/img/v2/retry.svg';
import { useAuth } from '@/lib/auth';
import { CardElement, Elements, useStripe, useElements } from '@stripe/react-stripe-js';
import DeleteIcon, {
  ReactComponent as DeleteIconSvg,
} from '../../../assets/img/delete-icon-v2.svg';
import ViewArrow from '@/assets/img/v2/view-arrow.png';
import BackIcon from '@/assets/img/back-icon.svg';
import { BrowserView, MobileView } from 'react-device-detect';
import Utils from '@/utils/util';
import { loadStripe } from '@stripe/stripe-js';
import { Button } from '@/components/Elements/Button';
import { AppointmentData } from '../types';
import { PaymentCard } from '../components/PaymentCard';
import { TableData } from '@/components/Table/TableData';
import ConfirmationDialogV2 from '@/components/ConfirmationDialog/ConfirmationDialogV2';
import { CheckoutForm } from '../components/CheckoutForm';
import { useUpdateCreditCard, useGetOrders } from '../api/updateParentProfile';
import PaymentCompletedModal from '../components/PaymentCompletedModal';
import { UseScreenOrientation } from '@/utils/Orientation';
import PAYMENT_TYPES from '@/config/constants';
import { useTranslation } from 'react-i18next';
import { businessCurrency } from '@/features/Language/api/getCountryCurrency';
import storage from '@/utils/storage';
type Props = {
  appointmentData?: AppointmentData;
  onSuccess: (appointmentData?: AppointmentData) => void;
  onBackClick?: () => void;
  addNewCard?: boolean;
  onBack?: (page: 'pet-profile') => void;
};
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY as string);

export default function MyPaymentMethods() {
  const isLandscape = UseScreenOrientation();
  const { user, refetchUser } = useAuth();
  const [isAddNewCard, setAddNewCard] = useState<boolean>(false);
  const [defaultCreditCard, setDefaultCreditCard] = useState<CreditCard>();
  const [cardList, setCardList] = useState<CreditCard[]>();
  const [billingList, setBillingList] = useState<BillingList[]>();
  const showBackNav = false;
  const [totalPages, setTotalPages] = useState(0);
  const perPage = 50;
  const [selectedPage, setSelectedPage] = useState(1);
  const deleteCreditCard = useUpdateCreditCard();
  const getOrders = useGetOrders();
  const [modalData, setViewModalData] = useState<BillingList>();
  const { t } = useTranslation();

  const country = storage.getKey('country');
  useEffect(() => {
    if (user?.creditCards && user.creditCards.length) {
      setCardList(user.creditCards);
      setDefaultCreditCard(user.defaultCard);
      //setAddNewCard(false);
    } else {
      //setAddNewCard(true);
    }
    //setBillingList(billingarray);
    getMyOrders();
  }, [user]);
  const onCardSelect = (card: CreditCard) => {
    setDefaultCreditCard(card);
  };

  useEffect(() => {
    refetchUser();
  }, []);

  const getMyOrders = async () => {
    const res = await getOrders.mutateAsync({
      businessId: user?.businessId,
      page: 0,
      perPage: 100,
    });
    if (res.list) {
      setBillingList(res.list);
    }
    //  setMyPets(res.list);
  };

  const onSuccess = async () => {
    await refetchUser();
    setAddNewCard(false);
  };

  const deleteCard = async (card: CreditCard) => {
    await deleteCreditCard.mutateAsync({ data: { deleteCardId: Number(card?.id) } });
    await refetchUser();
  };

  const getModalStatus = () => {
    if (!isLandscape && !isAddNewCard) {
      return true;
    }
    if (!!isLandscape && isAddNewCard) {
      return true;
    }
    if (!isLandscape && isAddNewCard) {
      return false;
    }
    if (!!isLandscape && !isAddNewCard) {
      return true;
    }
  };
  return (
    <section className="petsked-container-bg my-payment-methods">
      {!showBackNav ? (
        <>
          {getModalStatus() && (
            <div
              className={`heading-section left my-payment-add-new-btn ${
                !isLandscape ? 'remove-bg-white' : ''
              }`}
            >
              <div>
                <h5>
                  {t('Payment')} <span>{t('Methods')}</span>
                </h5>
                {/* <p>
                Lorem ipsum dolor sit amet, consectetur lorem adipiscing elit, sed do ipsum eiusmod.
              </p> */}
              </div>

              {!!isLandscape && (
                <div>
                  <button
                    className="petsked-button button-light"
                    onClick={() => {
                      setAddNewCard(true);
                    }}
                  >
                    {t('+ Add new card')}
                  </button>
                </div>
              )}
            </div>
          )}
          {getModalStatus() && (
            <>
              <div className="my-payment-card-list">
                {!isLandscape && !isAddNewCard ? (
                  <>
                    {cardList?.map((cl, index) => {
                      const isSelected = defaultCreditCard && cl.id == defaultCreditCard.id;
                      return (
                        <div className={`my-payment-payment-card`} onClick={() => onCardSelect(cl)}>
                          <div className="my-payment-left-section">
                            <div className="my-payment-card-type">
                              <VisaIcon />
                            </div>
                            <div className="my-payment-payment-card-details">
                              <p className="my-payment-card-no">{cl.number}</p>
                              <p className="my-payment-card-exp ">
                                {t('Expiry')} {cl.expireMonth}/{cl.expireYear}
                              </p>
                            </div>
                          </div>
                          <div className="my-payment-right-section">
                            <div className="my-payment-payment-card-details">
                              <p className="my-payment-card-exp ">
                                <div className="image-div">
                                  <img
                                    src={DeleteIcon}
                                    onClick={() => {
                                      deleteCard(cl);
                                    }}
                                  />
                                </div>
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div className="add-mb-btn">
                      <button
                        className="petsked-button button-light"
                        onClick={() => {
                          setAddNewCard(true);
                        }}
                      >
                        {t('+ Add new card')}
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    {cardList?.map((cl, index) => {
                      const isSelected = defaultCreditCard && cl.id == defaultCreditCard.id;
                      return (
                        <div className={`my-payment-payment-card`} onClick={() => onCardSelect(cl)}>
                          <div className="my-payment-left-section">
                            <div className="my-payment-card-type">
                              <VisaIcon />
                            </div>
                            <div className="my-payment-payment-card-details">
                              <p className="my-payment-card-no">{cl.number}</p>
                            </div>
                          </div>
                          <div className="my-payment-right-section">
                            <div className="my-payment-payment-card-details">
                              <p className="my-payment-card-exp ">
                                {t('Expiry')} {cl.expireMonth}/{cl.expireYear}
                              </p>
                              <p className="my-payment-card-exp ">
                                <div className="image-div">
                                  <img
                                    src={DeleteIcon}
                                    onClick={() => {
                                      deleteCard(cl);
                                    }}
                                  />
                                </div>
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
              <span className="payment-seperator">
                <hr />
              </span>
              <div className="payment-billing-history">
                <h5>{t('Billing history')}</h5>
                {/* <p>
              Lorem ipsum dolor sit amet, consectetur lorem adipiscing elit, sed do ipsum eiusmod.
            </p> */}
              </div>
              {!isLandscape && !isAddNewCard ? (
                <>
                  <div className="invoice-title-div">
                    <div className="inv-title">{t('INVOICE')}</div>{' '}
                  </div>
                  <div className="billing-mobile-div">
                    {billingList &&
                      billingList.length > 0 &&
                      billingList.map((item) => {
                        const showPaymentSuccess =
                          PAYMENT_TYPES.SUCCESS.indexOf(item?.paymentStatus) >= 0
                            ? false
                            : item?.paymentLink
                            ? true
                            : false;
                        return (
                          <div
                            className="billing-div"
                            onClick={() => {
                              setViewModalData(item);
                            }}
                          >
                            <div className="invoice-details">
                              {item.appointment ? (
                                <div className="pet-Parnet-name">
                                  {item?.appointment?.pet?.name}{' '}
                                  <span className="value-seperator"></span>{' '}
                                  {item?.appointment?.service?.name}
                                </div>
                              ) : (
                                <div className="pet-Parnet-name">
                                  {item?.roomBooking.accomodationType ===
                                  Utils.ACCOMODATION_TYPES.BOARDING
                                    ? 'Boarding Service'
                                    : 'Daycare Service'}
                                </div>
                              )}

                              <div className="pet-parnet-date">{businessCurrency(country,'USD')} {item?.paymentAmount}</div>
                            </div>
                            <div className="invoice-details">
                              <div className="pet-parnet-date">
                                {Utils.formatDateToString(item?.paymentDate)}
                              </div>
                              <div>
                                {showPaymentSuccess ? (
                                  <a href={item?.paymentLink} target="_blank" rel="noreferrer">
                                    <div
                                      className={`status-div ${
                                        showPaymentSuccess ? 'failed' : 'success'
                                      }`}
                                    >
                                      {showPaymentSuccess ? t('Retry') : t('Success')}
                                      {showPaymentSuccess ? <img src={RetryIcon} /> : null}
                                    </div>
                                  </a>
                                ) : (
                                  <div
                                    className={`status-div ${
                                      showPaymentSuccess ? 'failed' : 'success'
                                    }`}
                                  >
                                    {showPaymentSuccess ? t('Retry') : t('Success')}
                                    {showPaymentSuccess ? <img src={RetryIcon} /> : null}
                                  </div>
                                )}
                              </div>
                            </div>
                            <span className="billing-seperator">
                              <hr />
                            </span>
                          </div>
                        );
                      })}
                  </div>
                </>
              ) : (
                <div className="owner-list petsked-table mt-10 billing-table-data">
                  <TableData<BillingList>
                    data={billingList}
                    columns={[
                      {
                        title: t('INVOICE'),
                        field: 'appointment',
                        Cell({ entry: { appointment, roomBooking } }) {
                          return roomBooking ? (
                            <div className="petParnet-name">
                              {roomBooking?.pet?.name ? roomBooking?.pet?.name + ' | ' : ''} {' '}
                              {roomBooking?.accomodationType === Utils.ACCOMODATION_TYPES.DAY_CARE
                                ? 'DayCare Service'
                                : 'Boarding Service'}
                            </div>
                          ) : (
                            <div className="petParnet-name">
                              {appointment?.pet?.name} | {appointment?.service?.name}
                            </div>
                          );
                        },
                      },
                      {
                        title: t('DATE'),
                        field: 'paymentDate',
                        Cell({ entry: { paymentDate, createdAt } }) {
                          return (
                            <div className="petParnet-name"> {Utils.formatDateToString(paymentDate ? paymentDate : createdAt)}</div>
                          );
                        },
                      },
                      {
                        title: t('AMOUNT'),
                        field: 'paymentAmount',
                        Cell({ entry: { paymentAmount } }) {
                          return <div className="petParnet-name">${paymentAmount}</div>;
                        },
                      },

                      {
                        title: t('STATUS'),
                        field: 'paymentStatus',
                        Cell({ entry: { paymentLink, paymentStatus } }) {
                          const showPaymentSuccess =
                            PAYMENT_TYPES.SUCCESS.indexOf(paymentStatus) >= 0
                              ? false
                              : paymentLink
                              ? true
                              : false;
                          return (
                            <>
                              {showPaymentSuccess ? (
                                <a href={paymentLink} target="_blank" rel="noreferrer">
                                  <div
                                    className={`status-div ${
                                      showPaymentSuccess ? 'failed' : 'success'
                                    }`}
                                  >
                                    {showPaymentSuccess ? t('Retry') : t('Success')}
                                    {showPaymentSuccess ? <img src={RetryIcon} /> : null}
                                  </div>
                                </a>
                              ) : (
                                <div
                                  className={`status-div ${
                                    showPaymentSuccess ? 'failed' : 'success'
                                  }`}
                                >
                                  {showPaymentSuccess ? t('Retry') : t('Success')}
                                  {showPaymentSuccess ? <img src={RetryIcon} /> : null}
                                </div>
                              )}
                            </>
                          );
                        },
                        hide: false,
                      },
                      {
                        title: t('Action'),
                        field: 'paymentStatus',
                        Cell({ entry }) {
                          return (
                            <img
                              src={ViewArrow}
                              onClick={() => setViewModalData(entry)}
                              className="arrow-icon"
                            />
                          );
                        },
                      },
                    ]}
                    tableInitialState={{
                      tableTotalRecords: totalPages,
                      tablePageIndex: selectedPage,
                    }}
                    //onTableStateChange={onTableStateChange}
                    //isDataLoading={useGetEventsMutation.isLoading}
                  />
                  
                </div>
              )}
              {isAddNewCard && !!isLandscape && (
                <ConfirmationDialogV2
                  title={t("Add new card")}
                  description={t("Add details of your new billing card below")}
                  yesButtonLabel={t("Add New Card")}
                  noButtonLabel={t("Cancel")}
                  onCancel={() => {
                    setAddNewCard(false);
                  }}
                  onConfirm={() => {}}
                  open={isAddNewCard}
                  hideButtons={true}
                >
                  <div className="card-details my-payment-credit-card">
                    <Elements stripe={stripePromise}>
                      <CheckoutForm onSuccess={onSuccess} isMyPayment={true} />
                    </Elements>
                  </div>
                </ConfirmationDialogV2>
              )}
            </>
          )}
          {isAddNewCard && !isLandscape && (
            // <ConfirmationDialogV2
            //   title="Add new card"
            //   description="Add details of your new billing card below"
            //   yesButtonLabel="Add New Card"
            //   noButtonLabel="Cancel"
            //   onCancel={() => {
            //     setAddNewCard(false);
            //   }}
            //   onConfirm={() => {}}
            //   open={isAddNewCard}
            //   hideButtons={true}
            // >
            <>
              <div
                className="back-nav-new"
                onClick={() => {
                  setAddNewCard(false);
                }}
              >
                <img src={BackIcon} alt="back icon" />
                <span>{t('Back')}</span>
              </div>

              <div className="add-new-card-mobile-responsive">
                <div className="add-new-card-mobile-title">{t('Add new card')}</div>
                <div className="add-new-card-mobile-description">
                  {t('Add details of your new billing card below')}
                </div>
                <div className="card-details my-payment-credit-card">
                  <Elements stripe={stripePromise}>
                    <CheckoutForm onSuccess={onSuccess} isMyPayment={true} />
                  </Elements>
                </div>
              </div>
            </>
            // </ConfirmationDialogV2>
          )}
          {modalData && modalData?.id &&  (
              <PaymentCompletedModal
                open={true}
                onClose={() => {
                  setViewModalData(undefined);
                }}
                id={modalData?.id as string}
                selectedAppointment={modalData?.appointment}
                roomBooking={modalData?.roomBooking}
                lineItem ={{
                  total: parseFloat(modalData?.paymentAmount),
                  advPayment: 0,
                  serviceTip: 0,
                  othCharges: 0,
                  storeDisc: 0,
                  subTotal: 0,
                }}
                showDialogOnly={true}
                businessLocation={modalData.businessLocation}
                paymentProvider={modalData.paymentProvider}
              />
            )}
        </>
      ) : (
        <BackNav onClick={() => {}} />
      )}
    </section>
  );
}
